export default {
  All: -100,
};
